const PageNotFound = () => {
  return (
    <div 
      style={{
        width: "100%",
        height: "100%",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <h1>
        Sorry, page not found...
      </h1>
    </div>
  )
}

export default PageNotFound